// Flexbox & Grid Style Plugin
import { createSimpleProperty } from './helpers.js';

export default {
    id: 'flexbox',
    label: 'Flexbox & Grid',
    icon: 'Grid',
    properties: {
        flexBasis: {
            label: 'Basis',
            type: 'select',
            options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'auto', 'px', '0.5', '1.5', '2.5', '3.5', 'full'],
            default: 'auto',
            ...createSimpleProperty('basis')
        },
        flexDirection: {
            label: 'Direction',
            type: 'select',
            options: ['row', 'row-reverse', 'col', 'col-reverse'],
            default: 'row',
            ...createSimpleProperty('flex')
        },
        flexWrap: {
            label: 'Wrap',
            type: 'select',
            options: ['wrap', 'wrap-reverse', 'nowrap'],
            default: 'nowrap',
            ...createSimpleProperty('flex')
        },
        flex: {
            label: 'Flex',
            type: 'select',
            options: ['1', 'auto', 'initial', 'none'],
            default: 'initial',
            ...createSimpleProperty('flex')
        },
        flexGrow: {
            label: 'Grow',
            type: 'select',
            options: ['grow', 'grow-0'],
            default: 'grow-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['grow', 'grow-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        flexShrink: {
            label: 'Shrink',
            type: 'select',
            options: ['shrink', 'shrink-0'],
            default: 'shrink',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['shrink', 'shrink-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        order: {
            label: 'Order',
            type: 'select',
            options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'first', 'last', 'none'],
            default: 'none',
            ...createSimpleProperty('order')
        },
        gridTemplateColumns: {
            label: 'Template Columns',
            type: 'select',
            options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'none', 'subgrid'],
            default: 'none',
            ...createSimpleProperty('grid-cols')
        },
        gridColumn: {
            label: 'Column',
            type: 'select',
            options: ['auto', 'span-1', 'span-2', 'span-3', 'span-4', 'span-5', 'span-6', 'span-7', 'span-8', 'span-9', 'span-10', 'span-11', 'span-12', 'span-full'],
            default: 'auto',
            ...createSimpleProperty('col')
        },
        gridTemplateRows: {
            label: 'Template Rows',
            type: 'select',
            options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'none', 'subgrid'],
            default: 'none',
            ...createSimpleProperty('grid-rows')
        },
        gridRow: {
            label: 'Row',
            type: 'select',
            options: ['auto', 'span-1', 'span-2', 'span-3', 'span-4', 'span-5', 'span-6', 'span-7', 'span-8', 'span-9', 'span-10', 'span-11', 'span-12', 'span-full'],
            default: 'auto',
            ...createSimpleProperty('row')
        },
        gridAutoFlow: {
            label: 'Auto Flow',
            type: 'select',
            options: ['row', 'col', 'dense', 'row-dense', 'col-dense'],
            default: 'row',
            ...createSimpleProperty('grid-flow')
        },
        gridAutoColumns: {
            label: 'Auto Columns',
            type: 'select',
            options: ['auto', 'min', 'max', 'fr'],
            default: 'auto',
            ...createSimpleProperty('auto-cols')
        },
        gridAutoRows: {
            label: 'Auto Rows',
            type: 'select',
            options: ['auto', 'min', 'max', 'fr'],
            default: 'auto',
            ...createSimpleProperty('auto-rows')
        },
        gap: {
            label: 'Gap',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: '0',
            ...createSimpleProperty('gap')
        },
        justifyContent: {
            label: 'Justify Content',
            type: 'select',
            options: ['normal', 'start', 'end', 'center', 'between', 'around', 'evenly', 'stretch'],
            default: 'normal',
            ...createSimpleProperty('justify')
        },
        justifyItems: {
            label: 'Justify Items',
            type: 'select',
            options: ['start', 'end', 'center', 'stretch'],
            default: 'stretch',
            ...createSimpleProperty('justify-items')
        },
        justifySelf: {
            label: 'Justify Self',
            type: 'select',
            options: ['auto', 'start', 'end', 'center', 'stretch'],
            default: 'auto',
            ...createSimpleProperty('justify-self')
        },
        alignContent: {
            label: 'Align Content',
            type: 'select',
            options: ['normal', 'center', 'start', 'end', 'between', 'around', 'evenly', 'baseline', 'stretch'],
            default: 'normal',
            ...createSimpleProperty('content')
        },
        alignItems: {
            label: 'Align Items',
            type: 'select',
            options: ['start', 'end', 'center', 'baseline', 'stretch'],
            default: 'stretch',
            ...createSimpleProperty('items')
        },
        alignSelf: {
            label: 'Align Self',
            type: 'select',
            options: ['auto', 'start', 'end', 'center', 'stretch', 'baseline'],
            default: 'auto',
            ...createSimpleProperty('self')
        },
        placeContent: {
            label: 'Place Content',
            type: 'select',
            options: ['center', 'start', 'end', 'between', 'around', 'evenly', 'baseline', 'stretch'],
            default: 'stretch',
            ...createSimpleProperty('place-content')
        },
        placeItems: {
            label: 'Place Items',
            type: 'select',
            options: ['start', 'end', 'center', 'baseline', 'stretch'],
            default: 'stretch',
            ...createSimpleProperty('place-items')
        },
        placeSelf: {
            label: 'Place Self',
            type: 'select',
            options: ['auto', 'start', 'end', 'center', 'stretch'],
            default: 'auto',
            ...createSimpleProperty('place-self')
        }
    }
};
